export enum SidebarPosition{
    Right, 
    Left,
    Row
}